import { currentRoute, navStore, openDetour, replaceRoute, resetStack, type Route } from '../../app/navigation';
import type { V2AiJob } from '../../domain/aiJob';

// Where an Advanced AI result is opened (Owner contract 2026-09-13 §10 / §11): always the area
// workspace of the job, with the item sheet when the job is about a checklist row and the result
// sheet on top — the deep-link target of the notification, the in-app notice and the Task Center.
//
//   in the same area already  → the route is replaced (the sheet opens over the work in progress)
//   in the middle of work      → a DETOUR: Back returns to exactly where the inspector was (§11)
//   no work context (cold start from a notification, a root screen) → overview → area, so Back
//                                leads somewhere sensible instead of to an empty stack
export function openAdvancedResult(job: Pick<V2AiJob, 'id' | 'inspectionId' | 'areaId' | 'itemId'>): void {
  const target: Route = { screen: 'areaWorkspace', inspectionId: job.inspectionId, areaId: job.areaId, itemSheetId: job.itemId, findingId: null, advancedJobId: job.id };
  const state = navStore.get();
  const current = currentRoute(state);
  if (current.screen === 'areaWorkspace' && current.inspectionId === job.inspectionId && current.areaId === job.areaId) {
    replaceRoute(target);
    return;
  }
  if (state.stack.length <= 1 && (current.screen === 'home' || current.screen === 'inspectionList' || current.screen === 'reports' || current.screen === 'settings' || current.screen === 'signIn')) {
    resetStack([{ screen: 'home' }, { screen: 'inspection', inspectionId: job.inspectionId }, target]);
    return;
  }
  openDetour(target);
}
